import { all, takeEvery, put, call, fork } from 'redux-saga/effects';
import { notification } from '@iso/components';
import DataSourceApi from '@iso/lib/api/dataSourceHelper';
import actions from './actions';



export function* dataSourceCreateRequest() {
  yield takeEvery(actions.DATASOURCE_ADD_NEW, function* ({ payload }) {
    console.log("payloaddddd",payload);
    const result = yield call(DataSourceApi.create, payload.dataObj);
    console.log("resulttttttpayload",result);
    if (result.status === 0) {
      notification('error', result.message);
    } else {
      console.log("payload.dataObj","200");
      notification('success', result.message);
      yield put({
        type: actions.DATASOURCE_READ,
        success: true,
        msg: result.message,
      });
      window.location.reload(true)
      // payload.history.push('/dashboard/listDataSource');
    }
  });
}

export function* dataSourceReadRequest() {

  yield takeEvery(actions.DATASOURCE_READ, function* ({ payload }) {
    console.log("payloadddddRead",payload);
    try {
      const searchResult = yield call(DataSourceApi.read, payload.readFilter, payload.page);
      console.log("payloadddddsearchResult",searchResult);
      if (searchResult.status) {
        yield put(
          actions.dataSourceReadSearchSuccess(
            searchResult.result,
            true,
            searchResult.totalRecordCount,
            payload.page
          )
        );
      } else {
        notification('error', searchResult.message);
        yield put(
          actions.dataSourceReadSearchSuccess({},false,0,0)
        );
      }
    } catch (error) {
      console.log("Error::::::::::::::", error);
      //  yield put(actions.gitSearchSuccess());
    }
  })
}


/*****fetch record by id *************/
export function* dataSourceFindByIdRequest() {
  yield takeEvery(actions.DATASOURCE_FIND_BY_ID, function* ({ payload }) {
    try {
      const result = yield call(DataSourceApi.findById, payload.dataSourceId);
      if (result.success) {
        notification('success', result.message);
        yield put({
          type: actions.DATASOURCE_ITEM_SUCCESS,
          result: result.data,
          success: result.success
        });
      } else {
        notification('error', result.message);
      }
    } catch (error) {
    }
  });
}


export default function* rootSaga() {
  yield all([
    fork(dataSourceCreateRequest),
    fork(dataSourceReadRequest),
  ]);
}
